import React, { PropsWithChildren } from 'react';

import { classNames } from '@thinkific/chalk/utils';

import * as css from './MenuList.css';

interface MenuListProps extends PropsWithChildren {
  className?: string;
}

// Used as wrapper component for MenuItem components
const MenuList = ({ className, children }: MenuListProps) => {
  return <ul className={classNames(css.menuList, className)}>{children}</ul>;
};

export default MenuList;
